import React, { useState } from "react";
import { setLanguageThunk } from "../../store/thunks";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";

const LanguageSwitcher = ({ redirectTo = "/progress" }) => {
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const lang = useSelector((state) => state.ui.lang);
  const dispatch = useDispatch();

  const changeLanguage = (e) => {
    const lang = e.target.value;
    setLoading(true);
    dispatch(setLanguageThunk(lang, !!user.token)).then(() => {
      setLoading(false);
      if (location.pathname === "/app/activity/assessment") {
        window.location = "/app/activity/assessment";
      } else if (user.token) {
        window.location = redirectTo;
      }
    });
  };

  return (
    <div className="flex">
      {loading && <i className="mr-3 fas fa-spinner fa-spin" />}
      <select
        value={lang}
        onChange={changeLanguage}
        id="language-switcher"
        name="language"
        disabled={loading}
      >
        <option value="en">English</option>
        <option value="sp">Español</option>
        <option value="zh">中文</option>
        <option value="pt">Português</option>
        <option value="fr">Français</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
